import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { CallLogFilter } from '../types/integrationHub';

/**
 * GET /api/eraf/integration-hub/call-logs — 호출 이력 목록 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'call-logs', 'list', filters]
 */
export function useCallHistory(filters: CallLogFilter) {
  return useQuery({
    queryKey: ['integration-hub', 'call-logs', 'list', filters],
    queryFn: () =>
      integrationHubApi.listCallLogs({
        endpointCode: filters.endpointCode || undefined,
        protocol: filters.protocol || undefined,
        result: filters.result || undefined,
        minStatus: filters.minStatus !== '' ? filters.minStatus : undefined,
        from: filters.from || undefined,
        to: filters.to || undefined,
        traceId: filters.traceId || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'calledAt,desc',
      }),
    staleTime: 30_000,
  });
}
